import * as React from "react";
import DeviceContext from "../../../utils/indentifyDevice";
import { scroller } from "react-scroll";
const ReportsHeader = (props) => {
    const [title, titleLight] = props.title.split(" ");
    const desktop = DeviceContext().isDesktop;
    const moveToBottom = () => {
        scroller.scrollTo("understanding-transaction", {
            behaviour: "smooth",
        });
    };
    return (React.createElement("div", { className: `ed-component-heading ${props.title
            .toLocaleLowerCase()
            .replace(" ", "-")}` },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: `container-generic ${desktop ? "col-12 ps-0 pe-0" : "col-11 ps-0 pe-0"}` },
                    desktop ? (React.createElement("i", { className: `edel-icon-left-arrow`, onClick: () => props.redirectFunction() })) : (React.createElement("i", { className: `edel-icon-arrow-left1`, onClick: () => props.redirectFunction() })),
                    props.title && (React.createElement("div", { className: "generic-heading-title" },
                        React.createElement("span", { className: "title-bold" }, title),
                        React.createElement("span", { className: "title-light" }, titleLight))),
                    desktop ? ("") : (React.createElement("div", { className: "date-time-container-generic" },
                        props.dateText && (React.createElement("span", { className: "generic-date" }, props.dateText)),
                        props.timeString && (React.createElement("span", { className: "generic-time" }, props.timeString)))))))));
};
export default ReportsHeader;
